import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Mousetrap from 'mousetrap';
import { objectUtils } from '@codametrix/ui-common';
const isArrayEquivalent = (x, y)=>objectUtils.isEmpty(objectUtils.xorWith(x, y, objectUtils.isEqual));
class Keypress extends React.Component {
    componentDidUpdate(oldProps) {
        const { shortcuts } = oldProps;
        const equivalentArray = isArrayEquivalent(this.props.shortcuts, shortcuts);
        if (!equivalentArray) {
            this.debind(shortcuts);
            this.bindShortcuts(this.props.shortcuts);
        }
    }
    componentDidMount() {
        this.bindShortcuts(this.props.shortcuts);
    }
    bindShortcuts(shortcuts) {
        shortcuts.forEach((binding)=>{
            binding.keystrokes.forEach((keystroke)=>{
                Mousetrap.bind(keystroke, this.handleAction.bind(this, binding));
            });
        });
    }
    debind(shortcuts) {
        shortcuts.forEach((binding)=>{
            binding.keystrokes.forEach((keystroke)=>{
                Mousetrap.unbind(keystroke);
            });
        });
    }
    handleAction(shortcut) {
        const binding = {
            ...shortcut
        };
        const obj = objectUtils.get(this.props, binding.statePath);
        this.props.dispatcher({
            id: binding.id,
            value: obj
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "keypress",
            children: this.props.children
        });
    }
}
export { Keypress };
